module.exports = __webpack_public_path__ + "static/media/tacos.5f944291.jpg";